import { CrmAppConfiguration, CrmAppEnvironment } from 'common-module/core';
import { CrmFilterConfig } from 'common-module/filter';
import { CrmTableConfig } from 'common-module/table';
import { changelogConfig } from '@app/core/crm/changelog/changelog.config';
import { environment } from '@environments/environment';
import { CrmVersionConfig } from 'common-module/version';

import { authConfig } from './auth.config';

const crmEnv: CrmAppEnvironment = {
  ...environment,
};

export const appConfig: CrmAppConfiguration = {
  environment: crmEnv,
  modules: {
    auth: authConfig,
    filter: {
      actions: {
        clear: {
          enabled: true,
        },
      },
    } as CrmFilterConfig,
    table: {
      component: {
        emptyState: {
          title: 'crm.table.noData',
        },
      },
    } as CrmTableConfig,
    // modules.signature.views.deviceSelect.features
    signature: {
      views: {
        deviceSelect: {
          features: {
            show: false,
          },
        },
      },
    },
    changelog: changelogConfig,
  },
};
